<div class="login-page">
  <main class="login-page__content">
    <section class="login-card">
      <h2 class="login-card__title">Login</h2>

      <form [formGroup]="loginForm" (submit)="$event.preventDefault()" novalidate>
        <div class="login-grid">
          <label class="login-grid__label" for="email">Email Address:</label>
          <div class="login-grid__field">
            <input
              id="email"
              type="email"
              class="login-input"
              placeholder="Enter email address (required)"
              formControlName="email"
              [class.is-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
            />
          </div>

          <label class="login-grid__label" for="password">Password:</label>
          <div class="login-grid__field">
            <input
              id="password"
              type="password"
              class="login-input"
              placeholder="Enter password (required)"
              formControlName="password"
              [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
            />
          </div>
        </div>

        <div class="login-actions">
          <button type="button" class="login-button" [disabled]="isLoading" (click)="handleLogin()">
            <span class="glyphicon glyphicon-log-in" aria-hidden="true"></span>
            {{ isLoading ? 'Logging in...' : 'Login' }}
          </button>
        </div>
      </form>
    </section>
  </main>
</div>
